import { createServerFn } from "@tanstack/react-start";

import type { CertificationsResult } from "@/lib/training-pipeline";

/**
 * Public, read-only certification list for /grow and /start.
 * The Training Pipeline API key stays inside the handler's server module.
 */
export const listCertifications = createServerFn({ method: "GET" }).handler(
  async (): Promise<CertificationsResult> => {
    try {
      const { getCertifications } = await import("@/lib/training-pipeline.server");
      const certifications = await getCertifications();
      return { certifications };
    } catch (error) {
      // Log the detail server-side only; the client gets a plain message.
      console.error("[training-pipeline] failed to load certifications", error);
      return { error: "We couldn't load the certifications right now. Please try again shortly." };
    }
  },
);
